  
    import React from 'react';

    const processingloader = () => (
      <div className="text-left" style={{marginLeft:"15px"}}>
        <i className="fa fa-spinner fa-spin" /> We are processing. Please wait...
      </div>
    );

    export default processingloader;
  
